import {useContext, useEffect, useState} from "react";
import {useViewerStore} from "../../../../../../store/store";
import {Button, Flex, Select} from "antd";
import treeCartService from "../../../../../../services/treeCartService";
import {METER, TREE, UnitContext} from "../../../../../../contexts/UnitContext";
import {logger} from "../../../../../../services/loggingService";
import {ImArrowUp} from "react-icons/im";
import {GetRoundNum} from "../../../Three-JS-Viewer/Controllers/Common";
import * as _ from 'lodash';
import { TreeCartFormProps, TreeGroup, TreeUserData } from "../../../../../../@types/types";
import { MeshType } from "../../../../../../@types/enums";

export const defaultTreeCartInfo = (): Required<TreeUserData>['treeCartInfo'] => ({
    dbh: '',
    haul: '',
    height: '',
    isFormUpdated: false,
    location: '',
    noOfObst: 0,
    stump: '',
    total: 0,
});

const TreeCartForm: React.FC<TreeCartFormProps> = ({selectedTrees, onSubmit}) => {

    const {sceneViewer, treeCartItems} = useViewerStore();

    const {treeUnit, convertTypeQuantityToUnit, renderUnit} = useContext(UnitContext);


    const [autoSelectedHeight, setautoSelectedHeight] = useState<string[]>([]);
    const [selectedLocation, setSelectedLocation] = useState<string[]>([]);
    const [selectedStump, setSelectedStump] = useState<string[]>([]);
    const [selectedHaul, setSelectedHaul] = useState<string[]>([]);
    const [selectedNoOfObst, setSelectedNoOfObst] = useState<number[]>([]);
    const [selectedDBH, setSelectedDBH] = useState<string[]>([]);
    const [newCartTrees, setNewCartTrees] = useState<TreeGroup[]>([]);
    // const {treeCartItems} = useViewerStore.getState();
    // const treeCartItems = useViewerStore((state) => state.treeCartItems);
    const getNoOfObst = () => {
        const noOfObstOptions = [];
        for (let i = 0; i < 31; i++) {
            noOfObstOptions.push({value: i, label: i});
        }
        return noOfObstOptions;

    }

    const treeInfoColumn = [
        {title: 'Tree ID'},
        {title: 'Diameter'},
        {title: 'Height'},
        {title: 'Multiplier'},
        {title: 'DBH'},
        {title: 'Stump'},
        {title: 'Location'},
        {title: 'Haul'},
        {title: 'No. of Obstructions'},
    ];

    const locationOptions = [
        {value: 'Front', label: 'Front'},
        {value: 'Back', label: 'Back'},
        {value: 'Left Side', label: 'Left Side'},
        {value: 'Right Side', label: 'Right Side'},
    ]

    const dbhOptions = [
        {value: '0 - 11', label: '0-11'},
        {value: '12 - 23', label: '12-23'},
        {value: '24 - 35', label: '24-35'},
        {value: '36 - 47', label: '36-47'},
        {value: '48+', label: '48+'},
    ]


    const stumpOptions = [
        {value: 'Grinded', label: 'Grinded'},
        {value: 'Flush Cut', label: 'Flush Cut'},
    ]


    const haulOptions = [
        {value: 'Yes', label: 'Yes'},
        {value: 'No', label: 'No'},
    ]

    const noOfObstOptions = getNoOfObst();

    const getHeightRange = (height: number) => {
        if (height <= 9) {
            return '0 - 9'
        }
        if (height >= 10 && height <= 30) {
            return '10 - 30'
        }
        if (height >= 31 && height <= 50) {
            return '31 - 50'
        }
        if (height >= 51) {
            return '51+'
        }
    }

    //Validate params before submitting
    const validate = () => {
        let message;
        let valid = true;
        newCartTrees.forEach((tree, index: number) => {
            if (!valid) return;
            if (!selectedDBH[index] || !selectedLocation[index] || !selectedStump[index] || !selectedHaul[index] || selectedNoOfObst[index] === undefined) {
                message = `Please fill all fields of Tree ${newCartTrees[index].userData.treeId}`;
                valid = false;
            }
        });
        if (message) alert(message);
        return valid;
    }

    const addTreeCartInfo = async () => {

        //Validate params before submitting
        if (!validate()) return;

        try {

            // Hide the modal
            sceneViewer.removeViewerAlert();
            onSubmit?.();

            // Get the token for Excel service
            const authToken = await treeCartService.getExcelServiceToken();

            let updatedTreeItems = _.clone(newCartTrees);
            updatedTreeItems.forEach((tree: TreeGroup, i: number) => {
                const isFormUpdated = tree.userData.treeCartInfo?.isFormUpdated;
                if (isFormUpdated) {
                    const treeCartInfo = {
                        location: selectedLocation[i],
                        dbh: selectedDBH[i],
                        height: autoSelectedHeight[i],
                        stump: selectedStump[i],
                        haul: selectedHaul[i],
                        noOfObst: selectedNoOfObst[i],
                        total: 0,
                        isFormUpdated: true,
                    };
                    updatedTreeItems[i].userData.treeCartInfo = treeCartInfo;
                }

            });

            useViewerStore.setState({ treeCartItems: updatedTreeItems });

            // Get tree cutting cost using excel service
            updatedTreeItems.forEach(async (tree: TreeGroup, i: number) => {
                const info = tree.userData.treeCartInfo;
                if (!info) {
                    // handle missing form case early
                    logger.error(tree.userData.treeId, 'Missing treeCartInfo for tree');
                    alert('Missing treeCartInfo for tree')
                    return;
                }
                const { isFormUpdated, location, dbh, height, stump, haul, noOfObst } = info;
                if (!isFormUpdated) return;
                treeCartService.getTotalCostFromExcelService(authToken, location, Number(dbh), Number(height), stump, haul, noOfObst)
                    .then((totalFromExcelService) => {
                        // Update tree cart total from excel service
                        const treeCartInfo = {
                            ...info,
                            total: totalFromExcelService ? Number(totalFromExcelService) : 0,
                            isFormUpdated: false
                        };
                        updatedTreeItems[i].userData.treeCartInfo = treeCartInfo;
                        useViewerStore.setState({ treeCartItems: updatedTreeItems });
                    });
            });


            const olderValue = {"treeArr" : sceneViewer.selTreeArr, "cartArr" : treeCartItems }
            const newerValue ={"treeArr" : sceneViewer.selTreeArr, "cartArr" : newCartTrees}
            sceneViewer.addStep("GhostTreeAndCart", '', olderValue, newerValue);
            sceneViewer.deselectAllSelectedObjectsAndEndTask()
            const isTapandHold = useViewerStore.getState().isTapandHold;
            if (isTapandHold) {
                useViewerStore.setState({isTapandHold: false});
                useViewerStore.setState({isTabandHoldUp: false});
            }

        } catch (e) {
            logger.error(e)
            alert('Error Occurred While Calculating Tree Cost')
        }
    }

    useEffect(() => {
        // Auto select the height range based on the height of the tree
        let heightArr: string[] = [], locationArr: string[] = [], dbhArr: string[] = [], stumpArr: string[] = [], haulArr: string[] = [], obstArr: number[] = [],
            nonExitingTrees: TreeGroup[] = [];
        selectedTrees.forEach((selTree: TreeGroup) => {
            const isExist = treeCartItems.find(tree => tree.userData.treeId === selTree.userData.treeId);
            if (!isExist) {
                nonExitingTrees.push(selTree);
            }
        });
        const newCartItems = [...treeCartItems, ...nonExitingTrees];
        newCartItems.forEach(tree => {
            heightArr.push(getHeightRange(GetRoundNum(tree.userData.height)) ?? '');
            locationArr.push(tree.userData.treeCartInfo?.location ?? '');
            dbhArr.push(tree.userData.treeCartInfo?.dbh ?? '');
            stumpArr.push(tree.userData.treeCartInfo?.stump ?? stumpOptions[0].value);
            haulArr.push(tree.userData.treeCartInfo?.haul ?? haulOptions[0].value);
            obstArr.push(tree.userData.treeCartInfo?.noOfObst ?? 0);
        });
        setNewCartTrees(newCartItems);
        setautoSelectedHeight(heightArr);
        setSelectedLocation(locationArr);
        setSelectedDBH(dbhArr);
        setSelectedStump(stumpArr);
        setSelectedHaul(haulArr);
        setSelectedNoOfObst(obstArr);
    }, [selectedTrees, treeCartItems])

    const handleChange = (type: string, value: any, index: number) => {
        let updateCart = [...newCartTrees];
        if (!updateCart[index].userData.treeCartInfo) {
            updateCart[index].userData.treeCartInfo = defaultTreeCartInfo();
        }

        updateCart[index].userData.treeCartInfo.isFormUpdated = true;

        let newValues;
        switch (type) {
            case 'location':
                newValues = [...selectedLocation];
                newValues[index] = value;
                setSelectedLocation(newValues)
                break;
            case 'stump':
                newValues = [...selectedStump];
                newValues[index] = value;
                setSelectedStump(newValues)
                break;
            case 'dbh':
                newValues = [...selectedDBH];
                newValues[index] = value;
                setSelectedDBH(newValues)
                break;
            case 'haul':
                newValues = [...selectedHaul];
                newValues[index] = value;
                setSelectedHaul(newValues)
                break;
            case 'obst':
                newValues = [...selectedNoOfObst];
                newValues[index] = value;
                setSelectedNoOfObst(newValues)
                break;
            default:
                break;
        }
    }
    // Single Tree Add form
    if (newCartTrees.length === 1) return (
        <>
            <div className={'treeForm'}>
                <Flex vertical gap={15}>
                    <div>
                        <label className="form-label" htmlFor="treeCartHeightSelect">Height : ( auto-selected ) </label>
                        <Select
                            size="large"
                            disabled
                            placeholder="Select Height"
                            value={autoSelectedHeight[0]}
                        />
                    </div>

                    <div>
                        <label className="form-label" htmlFor="treeCartDBHSelect">DBH : </label>
                        <Select
                            size="large"
                            placeholder="Select DBH"
                            options={dbhOptions}
                            value={selectedDBH[0]}
                            onChange={(value) => handleChange('dbh', value, 0)}
                        />
                    </div>

                    <div>
                        <label className="form-label" htmlFor="treeCartStumpSelect">Stump : </label>
                        <Select
                            size="large"
                            placeholder="Select Stump"
                            options={stumpOptions}
                            value={selectedStump[0]}
                            onChange={(value) => handleChange('stump', value, 0)}
                        />
                    </div>

                    <div>
                        <label className="form-label" htmlFor="treeCartLocationSelect">Location : </label>
                        <Select
                            size="large"
                            placeholder="Select Location"
                            options={locationOptions}
                            value={selectedLocation[0]}
                            onChange={(value) => handleChange('location', value, 0)}
                        />
                    </div>

                    <div>
                        <label className="form-label" htmlFor="treeCartHaulSelect">Is Haul Wood : </label>
                        <Select
                            size="large"
                            placeholder="Select Haul"
                            options={haulOptions}
                            value={selectedHaul[0]}
                            onChange={(value) => handleChange('haul', value, 0)}
                        />
                    </div>

                    <div>
                        <label className="form-label" htmlFor="treeCartObstSelect">No Of Obst : </label>
                        <Select
                            size="large"
                            placeholder="Select No Of Obst"
                            options={noOfObstOptions}
                            value={selectedNoOfObst[0]}
                            onChange={(value) => handleChange('obst', value, 0)}
                        />
                    </div>

                    <Button type='primary' size='large' className="modal__submit" onClick={addTreeCartInfo}>
                        Submit
                    </Button>
                </Flex>
            </div>

        </>
    )
    // Multiple Tree Add form
    else return (
        <>
            <div className={'treeForm'}>
                <Flex vertical gap={15} style={{maxHeight:" calc(-200px + 100vh)", overflowY: "auto"}}>
                    <table className="tab__table">
                        <thead>
                        <tr>
                            {treeInfoColumn.map((item, index) => (
                                <th key={index} align="center">{item.title}</th>
                            ))}
                        </tr>
                        </thead>

                        <tbody>
                        {newCartTrees.map((data, index) => (
                            <tr key={index}>
                                <td align="center">
                                    {data.userData.treeId}
                                </td>
                                <td align="center">
                                    {(convertTypeQuantityToUnit(TREE as MeshType.Tree, Number(data.userData.crown_radius), METER).toFixed(2) as any) * 2} {renderUnit(treeUnit)}
                                </td>
                                <td align="center">
                                    {autoSelectedHeight[index]}
                                </td>
                                <td align="center" style={{
                                    "background": '#545b61',
                                    "color": data.userData.multiplier?.color
                                }}>M <ImArrowUp size={10}/>{data.userData.multiplier?.value}</td>
                                <td align="center"><Select style={{"width": "120px"}}
                                                           size="small"
                                                           placeholder="Select DBH"
                                                           value={selectedDBH[index]}
                                                           options={dbhOptions}
                                                           onChange={(value) => handleChange('dbh', value, index)}
                                /></td>
                                <td align="center"><Select style={{"width": "120px"}}
                                                           size="small"
                                                           placeholder="Select Stump"
                                                           value={selectedStump[index]}
                                                           options={stumpOptions}
                                                           onChange={(value) => handleChange('stump', value, index)}
                                /></td>
                                <td align="center"><Select style={{"width": "120px"}}
                                                           size="small"
                                                           placeholder="Location"
                                                           value={selectedLocation[index]}
                                                           options={locationOptions}
                                                           onChange={(value) => handleChange('location', value, index)}
                                /></td>
                                <td align="center"><Select style={{"width": "120px"}}
                                                           size="small"
                                                           placeholder="Select Haul"
                                                           value={selectedHaul[index]}
                                                           options={haulOptions}
                                                           onChange={(value) => handleChange('haul', value, index)}
                                /></td>
                                <td align="center"><Select style={{"width": "120px"}}
                                                           size="small"
                                                           placeholder="No Of Obst"
                                                           value={selectedNoOfObst[index]}
                                                           options={noOfObstOptions}
                                                           onChange={(value) => handleChange('obst', value, index)}
                                /></td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </Flex>
                <Button type='primary' size='large' className="modal__submit mt-1" onClick={addTreeCartInfo}>
                        Submit
                </Button>
                </div>
        </>
    )
}


export default TreeCartForm;
